import { ensureTemporal } from "@nijiurachan/js/util/time";
import { initializeBoardRuntime } from "@/config/developmentBoardRuntime";

export type ApplicationLoader = () => Promise<unknown>;
export type BoardRuntimeInitializer = () => Promise<unknown>;

const loadApplication: ApplicationLoader = () => import("@/app");

/**
 * Load application modules only after Temporal and board runtime are ready.
 *
 * Temporalの導入と板metadataの取得は互いに依存しないため並行して待つ。
 * 直列にすると、native Temporalを持たないブラウザではpolyfillの取得が
 * 終わるまで GET /boards/{slug} が始まらず、往復がそのまま積み上がる。
 * metadataの検証はTemporalを使わない純粋な判定で行う。
 */
export async function bootstrapApplication(
  loader: ApplicationLoader = loadApplication,
  initializeRuntime: BoardRuntimeInitializer = initializeBoardRuntime,
): Promise<void> {
  await Promise.all([ensureTemporal(), initializeRuntime()]);
  await loader();
}
